<div class="button-container">
  <div></div>
  <div>
    @if (model?.isCurrentEmployment && model?.fromDate) {
      <button mat-button [matMenuTriggerFor]="addmenu"
        class="btn-add add-new-employment" data-testid="add-employmentBtn">
        Update Current Employer
      </button>
    }
    <div>
      <mat-menu #addmenu="matMenu" class="button-menu-container" xPosition="after">
        <button mat-menu-item (click)="onAddNewCurrentEmployment(true, this.model)" class="menu-button"
          data-testid="employment-periodBtn">
          Employment Period
        </button>
        <button mat-menu-item (click)="onAddNewCurrentEmployment(false, this.model)" class="menu-button"
          data-testid="unemployment-periodBtn">
          Unemployment Period
        </button>
      </mat-menu>
    </div>
  </div>
</div>
@if (!isGapItem) {
  <div class="employment-info" [class.incomplete-mandatory]="needsMandatoryFieldsCompletion">
    @if (needsMandatoryFieldsCompletion) {
      <div class="incomplete-record-strip" role="status" data-testid="employment-mandatory-attention-strip">
        <mat-icon class="incomplete-strip-icon">priority_high</mat-icon>
        <span>Required information is missing. Tap the pencil icon to complete this record.</span>
      </div>
    }
    <div class="employment-header">
      <div class="date-info">
        @if (model?.toDate) {
          <span class="field-value">
            {{ model.fromDate | date: 'MMM yyyy' }} - {{ model?.toDate | date: 'MMM yyyy' }}
          </span>
        } @else {
          <span class="field-value">
            {{ model.fromDate | date: 'MMM yyyy' }} - Current
          </span>
        }
      </div>
      <div class="action-icons">
        <mat-icon svgIcon="pencil-icon" (click)="onUpdateEmp()" data-test="edit-button"
        [attr.data-testid]="model?.employer?.toLowerCase() + '-editBtn'"></mat-icon>
        @if (checkDeletePermission()) {
          <mat-icon svgIcon="delete-outlined" class="delete-outlined" (click)="onDeleteEmp()"
            data-test="delete-record-button" [attr.data-testid]="model?.employer?.toLowerCase() + '-deleteBtn'"
          ></mat-icon>
        }
      </div>
    </div>
    <div class="employer-info">
      @if (model?.employmentState == 'employed') {
        <span class="employer-value"
        [attr.data-testid]="model?.employer?.toLowerCase() + '-employmentHistory'">{{ model.employer }}</span>
      }
      @if (model?.employmentState == 'unemployed') {
        <span class="employer-value">Unemployed</span>
        @if (model?.reasonForLeaving) {
          <span class="unemployment-reason">{{ model.reasonForLeaving }}</span>
        }
      }
    </div>
  </div>
}

@if (isGapItem) {
  <div class="missing-data-container">
    <div class="gap-header">
      <mat-icon class="gap-warning-icon">warning</mat-icon>
      <span class="text-missing-data">Gap detected{{ gapDateRange ? ': ' + gapDateRange : '' }}</span>
    </div>
    <span class="missing-description">Add your employment or unemployment for this period</span>
    <div class="gap-actions">
      <button class="gap-btn" (click)="openEmploymentForm()">
        <mat-icon>add</mat-icon> Add Employment
      </button>
      <button class="gap-btn" (click)="openUnEmploymentForm()">
        <mat-icon>add</mat-icon> Add Unemployment
      </button>
    </div>
  </div>
}